import style from './Footer.module.scss'

export default function Footer(): JSX.Element {
    return <div className={style.footer}>Copyright © Mer Norway AS</div>
}
